// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../../assets/open-arrow.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wordTimesDiagram {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 0px 4px;
}

.wordTimesDiagram_title {
    font-weight: 600;
    font-size: 24px;
    line-height: 33px;
    text-align: center;
    color: #000000;
    margin-bottom: 12px;
}

.wordTimesDiagram_text {
    font-weight: 400;
    font-size: 12px;
    line-height: 16px;
    text-align: center;
    color: #000000;
    opacity: 0.5;
    margin-bottom: 8px;
}

.wordTimesDiagram_text_bold {
    font-weight: 700;
}

.bubblesWidget_title_row {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 12px;
    width: 100%;
    position: relative;
    margin-bottom: 12px;
}

.bubblesWidget_title_row .wordTimesDiagram_title {
    margin-bottom: 0;
}

.bubblesWidget_back_btn {
    width: 32px;
    height: 32px;
    border-radius: 8px;
    border: none;
    background: rgba(0, 0, 0, 0.05);
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: background 0.2s ease;
    flex-shrink: 0;
}

.bubblesWidget_back_btn:hover {
    background: rgba(0, 0, 0, 0.1);
}

.bubblesWidget_back_icon {
    width: 12px;
    height: 12px;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
    opacity: 0.7;
    transform: rotate(90deg);
}

.meetingPage_wordTimes .wordTimesDiagram {
    position: relative;
}
`, "",{"version":3,"sources":["webpack://./src/pages/meetingPage/components/bubblesWidget/BubblesWidget.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,cAAc;IACd,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,SAAS;IACT,WAAW;IACX,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,+BAA+B;IAC/B,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,gCAAgC;IAChC,cAAc;AAClB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,yDAA0D;IAC1D,wBAAwB;IACxB,2BAA2B;IAC3B,4BAA4B;IAC5B,YAAY;IACZ,wBAAwB;AAC5B;;AAEA;IACI,kBAAkB;AACtB","sourcesContent":[".wordTimesDiagram {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    padding: 0px 4px;\n}\n\n.wordTimesDiagram_title {\n    font-weight: 600;\n    font-size: 24px;\n    line-height: 33px;\n    text-align: center;\n    color: #000000;\n    margin-bottom: 12px;\n}\n\n.wordTimesDiagram_text {\n    font-weight: 400;\n    font-size: 12px;\n    line-height: 16px;\n    text-align: center;\n    color: #000000;\n    opacity: 0.5;\n    margin-bottom: 8px;\n}\n\n.wordTimesDiagram_text_bold {\n    font-weight: 700;\n}\n\n.bubblesWidget_title_row {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 12px;\n    width: 100%;\n    position: relative;\n    margin-bottom: 12px;\n}\n\n.bubblesWidget_title_row .wordTimesDiagram_title {\n    margin-bottom: 0;\n}\n\n.bubblesWidget_back_btn {\n    width: 32px;\n    height: 32px;\n    border-radius: 8px;\n    border: none;\n    background: rgba(0, 0, 0, 0.05);\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    transition: background 0.2s ease;\n    flex-shrink: 0;\n}\n\n.bubblesWidget_back_btn:hover {\n    background: rgba(0, 0, 0, 0.1);\n}\n\n.bubblesWidget_back_icon {\n    width: 12px;\n    height: 12px;\n    background-image: url('../../../../assets/open-arrow.svg');\n    background-size: contain;\n    background-position: center;\n    background-repeat: no-repeat;\n    opacity: 0.7;\n    transform: rotate(90deg);\n}\n\n.meetingPage_wordTimes .wordTimesDiagram {\n    position: relative;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
